import { Theme } from "@emotion/react";
import { PanelButtonStyleProp } from "./panel-buttons";

export const panelbuttonStyle = (theme: Theme): PanelButtonStyleProp => ({
    buttonSize: theme.sizes.iconButtonWidth,
    iconSize: "30px",
    hoverColour: theme.typographyColors.lessSubdued,
    disabledColour: theme.shades.three,
    selectedColour: theme.primaryColors.focus,
    activeColour: null,
});

export const infobuttonStyle = (theme: Theme): PanelButtonStyleProp => ({
    ...panelbuttonStyle(theme),
    selectedColour: theme.primaryColors.focus,
});

export const mapcontrollbuttonStyle = (theme: Theme): PanelButtonStyleProp => ({
    ...panelbuttonStyle(theme),
    activeColour: theme.primaryColors.focus,
});
